import debounce from 'lodash/debounce'
import socket from '@/libs/socket'

export default {
  computed: {
    saveSignupSource: function () {
      const prefix = this.update ? 'edit' : 'add'
      const type = this.isComment ? 'Comment' : 'Post'
      return `${prefix}${type}:{PATH}`
    },
    saveLoginMessage: function () {
      let userName = null
      if (this.comment && this.comment.user) {
        userName = this.comment.user.userName
      } else if (this.post && this.post.user) {
        userName = this.post.user.userName
      }

      if (userName) {
        return `To reply to ${userName}`
      }

      return 'To post your contribution'
    },
    isEdited: function () {
      return !this.update ||
        (this.$store.state.post && this.$store.state.post.posts[this.post.id] &&
          this.$store.state.post.posts[this.post.id].edited)
    }
  },

  methods: {
    save: debounce(function (callbackResponse) {
      this.saveNoDebounce(callbackResponse)
    }, 500, { leading: true, trailing: false }),

    saveNoDebounce: function (callbackResponse) {
      if (this.hasProfanity) {
        var err = this.error = this.hasProfanity
        return err
      }
      if (!this.isEdited && !this.edited) {
        this.reset()
        this.$emit('saved')
        this.saved = true
        this._set(this.createKey, null)
        return
      }
      if (!this.checkCanSave()) {
        if (this.isComment) {
          return
        }
        this.saving = false
        this.$emit('error', this.error)
        this._set('errorSaving', true)
        return
      }

      if (!this.isLoggedIn) {
        if (callbackResponse === false) {
          return
        }

        return this.$store.dispatch('showLoginModal', { source: this.saveSignupSource, callback: this.checkLoggedIn, signupMessage: this.saveLoginMessage })
      }
      this.error = ''
      this.saving = true
      return new Promise((resolve, reject) => {
        this.uploadAttachments().then(async () => {
          if (this.update) {
            await this.doUpdate()
          } else {
            await this.doCreate()
          }
          if (this.post) {
            this.$store.dispatch('fetchPollQuestions', { projectId: this.post.projectID })
            let reorderDispatchSort = 'sortAttachmentsForPost'
            let reorderEntityID = this.post.id
            if (!this.comment) {
              await this.$store.dispatch('setEdited', { id: this.post.id, edited: false })
            } else {
              reorderDispatchSort = 'sortAttachmentsForComment'
              reorderEntityID = this.comment.id
            }
            this.$store.dispatch(reorderDispatchSort, reorderEntityID).then(() => {
              let attachments = []
              if (this.comment) {
                attachments = this.$store.getters.attachmentsByComment(this.comment.id)
              } else {
                attachments = this.$store.getters.attachmentsByPost(this.post.id)
              }
              if (attachments) {
                this.displayNewAttachments(attachments)
              }
            })
          }

          resolve()
        }, (error) => {
          this.handleError(error, reject)
        }).catch((error) => {
          this.handleError(error, reject)
        })
      })
    },

    handleError: function (error, reject) {
      if (error && error.message) {
        error = error.message
      }
      console.error(`Unable to save: ${error}`)
      this.error = error
      this.saving = false
      this.$emit('error', this.error)
      this._set('errorSaving', true)
      reject(error)
    },

    checkLoggedIn: function () {
      if (!this.isLoggedIn) {
        this.error = 'Must be logged in to create a section'
        this.$emit('error')
      } else {
        this.save()
      }
    },

    doCreate: function () {
      return new Promise((resolve, reject) => {
        const params = this.createParams()

        this.$store.dispatch(this.dispatch.create, params).then((response) => {
          this.reset()
          this.$emit('incrementPostCount')
          this.$emit('saved', response)
          this.saved = true
          this._set(this.createKey, null)

          const socketParams = this.socketParams()
          socket.add(...socketParams)
          if (!this.isComment && this.projectType && this.projectType !== 'story') {
            this.setOrToggleText()
          }
          resolve()
        }, (error) => {
          this.saving = false
          this.error = error.message
          this.$emit('error', this.error)
          reject(error)
        })
      })
    },

    doUpdate: function () {
      return new Promise((resolve, reject) => {
        const params = this.updateParams()

        this.$store.dispatch(this.dispatch.update, params).then(() => {
          this.saveAttachments().then(() => {
            this.reset()
            this.$emit('saved')
            this.saved = true
            this._set(this.createKey, null)

            const socketParams = this.socketParams()
            socket.update(...socketParams)
            resolve()
          })
        }, (error) => {
          this.saving = false
          this.error = error.message
          this.$emit('error', this.error)
          this._set('errorSaving', true)
          reject(error)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  }
}
